
<template>
  <div class="mybox">
    <ar ></ar>
    <ar orientation="topRight"></ar>
    <ar orientation="bottomLeft"></ar>
    <ar orientation="bottomRight"></ar>  
    <custitle v-if="isTitle" :txt="txt"/>      
    <slot></slot>
  </div>
</template>

<script>
import ar from "@/components/vip/arrow"
import custitle from "@/components/vip/custitle"
export default {
  name: 'cusbox',
  props: {  
      txt: {
        type: String,
        default: "你的标题"
      },
      isTitle: {
          type: Boolean,
          default: true
      }    
  },
  data () {  
    return {     
     
    }
  },
  methods: {
 
  },
  mounted () {
  
  },
  components:{
      ar,
      custitle
  }
}
</script>
<style lang="scss">
.mybox{
    height: 100%;
    width: 100%;
    position: relative;
    border: 2px solid #1D4191;
    background: rgba(76,151,230,0.06);
    display: flex;
    flex-direction: column;
    .title{
      display: flex;
      
    }
 }
 
</style>
